import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import CompanyAboutLoader from '../../../components/shared/SkeletonLoaders/CompanyAboutLoader/CompanyAboutLoader.jsx';
import CompanyProfileHeaderLoader from '../../../components/shared/SkeletonLoaders/CompanyProfileHeaderLoader/CompanyProfileHeaderLoader.jsx';
import { copyToClipboard } from '../../../helpers/commonHelper';
import { useSocialShare } from '../../../helpers/socialShareUtils';
import { getCompanyProfile } from '../../../redux/actions/companyProfileActions';
import newUserAppUrl from '../../../routing/newUserApp';
import urls from '../../../routing/urls';
import { selectCompanyProfile, selectCompanyProfileLoading } from '../../../selectors/companyProfileSelectors.js';

import About from './About/About.jsx';
import ProfileHeader from './ProfileHeader/ProfileHeader.jsx';

import styles from './Profile.module.scss';

const Profile = ({ isPublic }) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { companyName } = useParams();
  const type = 'company';

  const company = useSelector(selectCompanyProfile);
  const loading = useSelector(selectCompanyProfileLoading);

  useEffect(() => {
    dispatch(getCompanyProfile(companyName, navigate));
  }, [dispatch]);

  const handleSocialShare = useSocialShare(companyName, company, type);

  const handleCopyLink = () => {
    const link = newUserAppUrl + urls.companyProfile.replace(':companyName', companyName);
    if (link) {
      copyToClipboard(link, type);
    }
  };

  const renderHeader = () =>
    loading || !company ? (
      <CompanyProfileHeaderLoader />
    ) : (
      <ProfileHeader
        identifier={companyName}
        company={company}
        handleSocialShare={handleSocialShare}
        onCopyLink={handleCopyLink}
        isPublic={isPublic}
      />
    );

  const renderAbout = () => (loading || !company ? <CompanyAboutLoader /> : <About company={company} />);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.companyTitle}>{t('headers.companyProfile')}</div>
        <div className={styles.subContainer}>
          <div className={styles.headerPopupCont}>{renderHeader()}</div>
          <div>{renderAbout()}</div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
